import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useMediaQueryContext } from '@fourthwall/components';
import { useOnceInView, useTagManager } from '@hooks';
import { routing } from '@utils/routing';
import * as Carousel from '../../components/Carousel/Carousel';
const ID = 'ordersToSend';
const CarouselItem = styled(Carousel.Item) `
  background-color: rgba(225, 154, 0, 0.15);

  &:hover {
    background-color: rgba(225, 154, 0, 0.25);
  }
`;
export const OrdersToSendSlide = ({ data, 'data-role': dataRole, }) => {
    const { tablet } = useMediaQueryContext();
    const navigate = useNavigate();
    const tagManager = useTagManager();
    const unfulfilledOrdersCount = data.ordersToSend?.unfulfilledOrdersCount || 0;
    const viewRef = useOnceInView(() => {
        tagManager.trigger('mini_recommendation_view', {
            type: ID,
        });
    });
    if (!unfulfilledOrdersCount) {
        return null;
    }
    const redirectToOrdersToSend = () => {
        tagManager.trigger('mini_recommendation_click', {
            type: ID,
        });
        navigate(routing.contributions.fulfillment);
    };
    return (React.createElement(CarouselItem, { ref: viewRef, "data-role": dataRole, "data-analytics": ID, onClick: redirectToOrdersToSend },
        React.createElement(Carousel.ContentLeft, null,
            React.createElement(Carousel.ItemEmote, null, "\uD83D\uDCE6"),
            tablet && (React.createElement(Carousel.ItemText, null,
                "You have ",
                unfulfilledOrdersCount,
                " ",
                unfulfilledOrdersCount === 1 ? 'order' : 'orders',
                ' ',
                "left to send")),
            !tablet && (React.createElement(Carousel.ItemText, null,
                unfulfilledOrdersCount,
                " ",
                unfulfilledOrdersCount === 1 ? 'order' : 'orders',
                " left to send")))));
};
